import React, { useEffect, useState } from 'react';
import '../css/DashboardHome.css';
import api from '../utils/axiosConfig';

function DashboardHome() {
  const [stats, setStats] = useState({
    totalUsers: 0,
    activeUsers: 0,
    totalParticipants: 0,
    activeParticipants: 0,
    loading: true,
    error: null
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        // Fetch both users and participants in parallel
        const [usersRes, participantsRes] = await Promise.all([
          api.get('/api/users'),
          api.get('/api/participants')
        ]);

        const users = usersRes.data;
        const participants = participantsRes.data;

        // Compute totals
        const totalUsers = users.length;
        const totalParticipants = participants.length;

        // Compute active ones (assuming each has `active` or `status` flag)
        const activeUsers = users.filter(u => u.active === true || u.status === 'active').length;
        const activeParticipants = participants.filter(p => p.active === true || p.status === 'active').length;

        setStats({
          totalUsers,
          activeUsers,
          totalParticipants,
          activeParticipants,
          loading: false,
          error: null
        });
      } catch (err) {
        console.error('Error fetching dashboard stats:', err);
        setStats(prev => ({ ...prev, loading: false, error: 'Fehler beim Laden der Daten' }));
      }
    };

    fetchStats();
  }, []);

  if (stats.loading) {
    return <div className="dashboard-home"><p>Lade Daten...</p></div>;
  }

  if (stats.error) {
    return <div className="dashboard-home"><p>{stats.error}</p></div>;
  }

  return (
    <div className="dashboard-home">
      <h1>Admin-Bereich</h1>
      <div className="dashboard-summary">
        <div className="summary-card">
          <h3>Benutzer</h3>
          <p>Gesamt: {stats.totalUsers}</p>
          <p>Aktiv: {stats.activeUsers}</p>
        </div>
        <div className="summary-card">
          <h3>Teilnehmer</h3>
          <p>Gesamt: {stats.totalParticipants}</p>
          <p>Aktiv: {stats.activeParticipants}</p>
        </div>
      </div>
    </div>
  );
}

export default DashboardHome;
